/**
 * Decodifica o PAYLOAD de um JWT (a parte do meio), sem validar assinatura — a
 * validação REAL é do backend (fronteira de segurança). Aqui é só para a UX ler
 * as roles do Keycloak e mostrar/esconder o que o usuário pode fazer. Sem depender
 * de `jwt-decode` (não instalado): base64url → JSON, tolerante a UTF-8.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const part = token.split(".")[1];
    if (!part) return null;
    // base64url → base64 (+ padding).
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    const json = decodeURIComponent(
      atob(padded)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/**
 * Extrai as roles do CLIENT informado de `resource_access[clientId].roles`.
 * É a mesma chave que o backend lê (`estudo-rede-interno-web`). Retorna [] se o
 * token não tiver o claim (ex.: SSO ainda sem o mapper) ou não decodificar.
 */
export function clientRolesFromToken(token: string | null, clientId: string): string[] {
  if (!token) return [];
  const payload = decodeJwtPayload(token);
  const ra = payload?.["resource_access"] as
    | Record<string, { roles?: unknown }>
    | undefined;
  const roles = ra?.[clientId]?.roles;
  return Array.isArray(roles) ? roles.filter((r): r is string => typeof r === "string") : [];
}
